import { QueryClient } from "@tanstack/react-query";

import { refreshMunicipalPropertyCatalog } from "./refresh-municipal-property-catalog";
import { refreshMunicipalPropertyConsumption } from "./refresh-municipal-property-consumption";

export async function refreshMunicipalPropertyManagement({
  queryClient,
  scope,
  throwOnError = false,
}: {
  queryClient: QueryClient;
  throwOnError?: boolean;
  scope: Parameters<typeof refreshMunicipalPropertyCatalog>[0]["scope"];
}): Promise<void> {
  await Promise.all([
    refreshMunicipalPropertyCatalog({ queryClient, scope, throwOnError }),
    refreshMunicipalPropertyConsumption({ queryClient, scope, throwOnError }),
  ]);
}
